<template>
    <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obModal.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="6" sm="6">
                                <v-text-field label="Módulo *" color="textbox" v-model="obModal.modulo"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(3,obModal.modulo,100))" outlined
                                    dense />
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-text-field label="Icono *" color="textbox" v-model="obModal.icono"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(3,obModal.icono,100))" outlined dense />
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-text-field label="Orden *" color="textbox" v-model="obModal.orden"
                                    :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-autocomplete label="Estado *" color="textbox" :items="_.filter(listGeneral.listEstado,{'visualiza':'true'})"
                                    item-text="nombre_estado" item-value="id_estado" :rules="requeridoRegla"
                                    v-model='obModal.idEstado' outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="clear" :disabled="disabled">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalModuloComponent',
        inject: ['close', 'submit'],
        props: {
            open: {
                type: Boolean,
                default: false
            },
            obModal: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            },
        },
        data: () => ({
            disabled: false
        }),
        created(){
            if(!_.isUndefined(this.$refs.form))
                this.$refs.form.resetValidation();
        },
        methods: {
            clear(){
                if(!_.isUndefined(this.$refs.form))
                    this.$refs.form.resetValidation();

                this.close(false);
            },
            validar(){
                try {
                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        this.submit();
                } catch (ex) {
                    mensajesAlerta(ex, 'I');
                    this.disabled = false;
                }
            }
        }
    }
</script>